import {dataTestId} from '@hconnect/uikit'
import {Add} from '@mui/icons-material'
import {Button, Stack, Typography, useTheme} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {DayPeriod} from '../types'

interface StrengthTargetMobileHeaderProps {
  selectedTab: DayPeriod | 'overview'
  hasTargetsForSelectedDay: boolean
  isReadOnly: boolean
  onNewTarget: () => void
}

export const StrengthTargetMobileHeader: React.FC<StrengthTargetMobileHeaderProps> = ({
  selectedTab,
  hasTargetsForSelectedDay,
  isReadOnly,
  onNewTarget
}) => {
  const {t} = useTranslation()
  const theme = useTheme()

  const showNewTargetButton = !isReadOnly && selectedTab !== 'overview' && hasTargetsForSelectedDay

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      {...dataTestId('strength_header_mobile')}
    >
      <Typography
        variant="h6"
        sx={{fontWeight: 600, color: theme.palette.text.primary}}
        {...dataTestId('strength_title_mobile')}
      >
        {t('materialsSettings.strengthTargets.strength')}
      </Typography>
      {showNewTargetButton && (
        <Button
          variant="text"
          startIcon={<Add />}
          onClick={onNewTarget}
          sx={{
            textTransform: 'none',
            fontSize: '14px',
            fontWeight: 500,
            color: theme.palette.primary.main
          }}
          {...dataTestId('new_target_button_mobile_top')}
        >
          {t('materialsSettings.strengthTargets.newTarget')}
        </Button>
      )}
    </Stack>
  )
}
